<div class="fw-bold bg-white p-3 rounded-5 mb-3 shadow">
    <!-- Первый ряд -->
    <div class="d-flex justify-content-between">
        <div>
            <label class="labelInformation" disabled>
                <strong *ngIf="customer">{{customer.userNames}}&nbsp;&nbsp;&nbsp;&nbsp;</strong>
                <span>{{information}}</span>
            </label>
        </div>
        <div class="col btn-back text-end">
            <button class="btn btn-secondary" (click)="location.back()">Back</button>
        </div>
    </div>

    <!-- Второй ряд -->
    <div>
        <app-customer-form [hidden]="currentTab==='users' || currentTab==='reports'" (handleUserLoaded)="onUserLoaded($event)" [isAdmin]="permissionsService.isAdmin"></app-customer-form>
        <app-assign-users *ngIf="currentTab==='users'" [customerDataInput]="customer"></app-assign-users>
    </div>
</div>

<div class="bg-white p-3 rounded-5 mb-3 shadow">
    <!--#region - Tab List - -->
    <ul class="nav nav-tabs mb-3" id="transferTypeTab" role="tablist">
        <li class="nav-item" role="presentation">
            <button class="nav-link" [class.active]="currentTab === 'sims'" id="sims-tab-header" data-bs-toggle="tab" data-bs-target="#sims-tab" type="button" role="tab" aria-selected="false" tabindex="-1">
                SIMs
            </button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link" [class.active]="currentTab === 'plans'" id="plans-tab-header" data-bs-toggle="tab" data-bs-target="#plans-tab" type="button" role="tab" aria-selected="false" tabindex="-1">
                Plans
            </button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link" [class.active]="currentTab === 'reports'" id="reports-tab-header" data-bs-toggle="tab" data-bs-target="#reports-tab" type="button" role="tab" aria-selected="false" tabindex="-1">
                Reports
            </button>
        </li>
        <li class="nav-item" role="presentation" *ngIf="!permissionsService.isDistributorLevel">
            <button class="nav-link" [class.active]="currentTab === 'users'" id="users-tab-header" data-bs-toggle="tab" data-bs-target="#users-tab" type="button" role="tab" aria-selected="false" tabindex="-1">
                Users
            </button>
        </li>
        <!--
        <li class="nav-item" role="presentation">
            <button class="nav-link" [class.active]="currentTab === 'tickets'" id="tickets-tab-header" data-bs-toggle="tab" data-bs-target="#tickets-tab" type="button" role="tab" aria-selected="false" tabindex="-1">
                Tickets
            </button>
        </li>
        -->
        <li class="nav-item" role="presentation">
            <button class="nav-link" [class.active]="currentTab === 'notes'" id="notes-tab-header" data-bs-toggle="tab" data-bs-target="#notes-tab" type="button" role="tab" aria-selected="false" tabindex="-1">
                Notes
            </button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link" [class.active]="currentTab === 'billing'" id="billing-tab-header" data-bs-toggle="tab" data-bs-target="#billing-tab" type="button" role="tab" aria-selected="false" tabindex="-1">
                Billing
            </button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link" [class.active]="currentTab === 'history'" id="history-tab-header" data-bs-toggle="tab" data-bs-target="#history-tab" type="button" role="tab" aria-selected="false" tabindex="-1">
                History
            </button>
        </li>
    </ul>
    <!--#endregion - Tab List - -->
    <!--#region - Tab Contents - -->
    <div class="tab-content">
        <!--#region - SIMs Tab - -->
        <div class="tab-pane fade" [class.show]="currentTab === 'sims'" [class.active]="currentTab === 'sims'" id="sims-tab" role="tabpanel" aria-labelledby="#sims-tab-header">
            <div class="row" *ngIf="currentTab==='sims'">
                <div class="col-10">
                    <h2 class="title-list">Manage SIM cards associated with this account</h2>
                </div>
                <div class="col-2 d-flex justify-content-end mb-3" *ngIf="permissionsService.inventory.createPermission">
                    <button class="btn btn-primary" (click)="onAddSim()">Add SIM</button>
                </div>
                <div class="row">
                    <div class="col-12">
                        <app-table-control [columns]="simsColumns"
                                           [data]="sims" [pageSize]="10"
                                           [actionButtons]="simsActionButtons"
                                           [showActions]="this.permissionsService.isAdmin"
                                           (actionClick)="onSimsAction($event)"
                                           [rowClass]="getRawClass"
                                           >
                        </app-table-control>
                    </div>
                </div>
            </div>
        </div>
        <!--#endregion - SIMs Tab - -->
        <!--#region - Plans Tab - -->
        <div class="tab-pane fade" [class.show]="currentTab === 'plans'" [class.active]="currentTab === 'plans'" id="plans-tab" role="tabpanel" aria-labelledby="#plans-tab-header">
            @if (currentTab==='plans') {
            <app-assign-plan *ngIf="permissionsService.isAdmin" [customerDataInput]="customer"></app-assign-plan>
            <app-list-customer-plans [customerDataInput]="customer"></app-list-customer-plans>
            }
        </div>
        <!--#endregion - Plans Tab - -->
        <!--#region - Reports Tab - -->
        <div class="tab-pane fade" [class.show]="currentTab === 'reports'" [class.active]="currentTab === 'reports'" id="reports-tab" role="tabpanel" aria-labelledby="#reports-tab-header">
            <div class="reports-toolbar">
                <button class="btn btn-secondary custom-hover custom-active" type="button" aria-expanded="false" (click)="exportToExcelAllUsage()">
                    <i class="bi bi-file-earmark-spreadsheet"></i>
                    Export All Usage
                </button>
            </div>
            <div class="usages-list">
                @if (!customerPlans){
                <div>Loading...</div>
                }
                @else {
                @for (plan of customerPlans; track plan.key) {
                <div class="usages-item">
                    <h3>
                        <span class="plan-name">{{plan.value}}</span>
                        <div class="dropdown float-end" style="width: 140px;">
                            <button class="btn btn-secondary dropdown-toggle custom-hover custom-active"
                                    type="button" id="dropdownReportButton" data-bs-toggle="dropdown"
                                    aria-expanded="false">
                                <i class="bi bi-file-earmark-spreadsheet"></i>
                                Export data
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="dropdownReportButton">
                                <li>
                                    <a class="dropdown-item custom-hover" (click)="exportToExcelListPlanDevicesConsolidated(plan)">
                                        <i class="bi bi-file-earmark-text"></i>
                                        Current Usage - Consolidated
                                    </a>
                                </li>
                                <li>
                                    <a class="dropdown-item custom-hover" (click)="exportToExcelListPlanDevices(plan)">
                                        <i class="bi bi-file-earmark-text"></i>
                                        Current Usage - Detailed
                                    </a>
                                </li>
                                <li>
                                    <a class="dropdown-item custom-hover" (click)="exportToExcelListPlanDevicesHistoricConsolidated(plan)">
                                        <i class="bi bi-file-earmark-text"></i>
                                        Historic Usage - Consolidated
                                    </a>
                                </li>
                                <li>
                                    <a class="dropdown-item custom-hover" (click)="exportToExcelListPlanDevicesHistoric(plan)">
                                        <i class="bi bi-file-earmark-text"></i>
                                        Historic Usage - Detailed
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </h3>
                    <app-consumption-view [data]="plan.usageData"></app-consumption-view>
                </div>
                } @empty {
                <div>No data</div>
                }
                }
            </div>
        </div>
        <!--#endregion - Reports Tab - -->
        <!--#region - Users Tab - -->
        <div class="tab-pane fade" [class.show]="currentTab === 'users'" [class.active]="currentTab === 'users'" id="users-tab" role="tabpanel" aria-labelledby="#users-tab-header">
            <ng-container *ngIf="currentTab==='users' && !permissionsService.isDistributorLevel">
                <!--
                <app-assign-users [customerDataInput]="customer"></app-assign-users>
                -->
                <app-list-customer-users [customerDataInput]="customer"></app-list-customer-users>
            </ng-container>
        </div>
        <!--#endregion - Users Tab - -->
        <!--#region - Tickets Tab - -->
        <!--
        <div class="tab-pane fade" [class.show]="currentTab === 'tickets'" [class.active]="currentTab === 'tickets'" id="tickets-tab" role="tabpanel" aria-labelledby="#tickets-tab-header">
            <div>Tickets Content</div>
        </div>
        -->
        <!--#endregion - Tickets Tab - -->
        <!--#region - Notes Tab - -->
        <div class="tab-pane fade" [class.show]="currentTab === 'notes'" [class.active]="currentTab === 'notes'" id="notes-tab" role="tabpanel" aria-labelledby="#notes-tab-header">
            <div class="row" *ngIf="currentTab==='notes'">
                <div class="row">
                    <div class="col-10">
                        <h2 class="title-list">Notes</h2>
                    </div>
                    <div class="col-2 d-flex justify-content-end mb-3">
                        <button *ngIf="permissionsService.isAdmin" class="btn btn-primary" (click)="addNote()">Add Note</button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <app-table-control [columns]="notesColumns"
                                           [pageSize]="10"
                                           [showActions]="true"
                                           [actionButtons]="notesActionButtons"
                                           (actionClick)="onNotesAction($event)"
                                           [serverDataRequest]="loadNotesReq"
                                           (onLoadPage)="onLoadNotes($event)"
                                           >
                        </app-table-control>
                    </div>
                </div>
            </div>
        </div>
        <!--#endregion - Notes Tab - -->
        <!--#region - Billing Tab - -->
        <div class="tab-pane fade" [class.show]="currentTab === 'billing'" [class.active]="currentTab === 'billing'" id="billing-tab" role="tabpanel" aria-labelledby="#billing-tab-header">
            <div>Billing Content</div>
        </div>
        <!--#endregion - Billing Tab - -->
        <!--#region - History Tab - -->
        <div class="tab-pane fade" [class.show]="currentTab === 'history'" [class.active]="currentTab === 'history'" id="history-tab" role="tabpanel" aria-labelledby="#history-tab-header">
            <div class="row" *ngIf="currentTab==='history'">
                <div class="row">
                    <div class="col-12">
                        <h2 class="title-list">Audit Log</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <app-table-control [columns]="auditColumns"
                                           [pageSize]="10"
                                           [serverDataRequest]="loadAuditReq"
                                           (onLoadPage)="onLoadAudit($event)"
                                           [rowClass]="getRawClass">
                        </app-table-control>
                    </div>
                </div>
            </div>
        </div>
        <!--#endregion - History Tab - -->
    </div>
    <!--#endregion - Tab Contents - -->
</div>


<!--#region - Modal Forms - -->
<div id="modalAddSim" class="modal fade" tabindex="-1" aria-hidden="true">
    <div class="d-flex align-items-center justify-content-center full-height">
        <div class="modal-dialog" style="max-width: 80vw;">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" style="font-weight: bold">Create SIM</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">

                    <div class="row">
                        <div class="col">
                            <label class="input-label">Customer Plan<span class="required">*</span></label>
                            <app-dropdown-control required="Customer Plan is required"
                                                  [items]="customerPlans"
                                                  [(selectedKey)]="customerPlanSelected">
                            </app-dropdown-control>
                        </div>
                    </div>
                    <br />
                    <app-device-form [isExternalDialog]="true"
                                     [attr.isAdmin]="true"
                                     (simCreated)="onAddSim($event)"
                                     [disableSave]="!customerPlanSelected">

                    </app-device-form>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="modalAssignDeviceTransfer" class="modal fade" tabindex="-1" aria-hidden="true">
    <div class="d-flex align-items-center justify-content-center full-height">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" style="font-weight: bold">
                        Device Transfer
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body" style="width: 500px">
                    <div class="row">
                        <div class="col">
                            <label class="input-label">Customer Plan<span class="required">*</span></label>
                            <app-dropdown-control required="Customer Plan is required"
                                                  [items]="customerPlans | plansForTransfer"
                                                  [(selectedKey)]="customerPlanSelected">
                            </app-dropdown-control>
                        </div>
                    </div>
                    <!--
                    <div *ngIf="assignTransferAction?.item?.status !== 2" class="row mt-3">
                        <div class="col" style="display: flex; align-items: center;">
                            <input type="checkbox" class="checkbox" id="active" name="active" [(ngModel)]="remainUsageData" />
                            <label for="active" class="m-2">Remain previous usage data</label>
                        </div>
                    </div>
                    -->
                </div>

                <div class="modal-footer">
                    <button type="button" [disabled]="!customerPlanSelected" class="btn btn-danger" data-bs-dismiss="modal" (click)="onSimsAction(assignTransferAction, true)">
                        Transfer
                    </button>
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="modalSelectReportPeriod" class="modal fade" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel" style="font-weight: bold">
                    Report Filters
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                </button>
            </div>
            <div class="modal-body">
                <div class="fw-bold bg-white p-3 rounded-5 mb-5">
                    <!-- Primera fila -->
                    <div class="row mt-3">
                        <div class="col">
                            <label>Please select the start and end dates for the report query.</label>
                        </div>
                    </div>

                    <!-- Segunda fila -->
                    <div class="row mt-3">
                        <div class="col">
                            <label for="fromDate">From Date</label>
                            <input type="date" class="form-control input-label"
                                   (input)="checkFieldsFilter()" [(ngModel)]="fromDate" id="fromDate" name="fromDate" />
                        </div>

                        <div class="col">
                            <label for="toDate">To Date</label>
                            <input type="date" class="form-control input-label"
                                   (input)="checkFieldsFilter()" [(ngModel)]="toDate"
                                   [min]="minDate()" id="toDate" name="toDate" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                    Close
                </button>
                <button type="button" class="btn btn-primary" [disabled]="!fieldsCompletedFilter" (click)="dialog.close(true)">
                    Generate Report
                </button>
            </div>
        </div>
    </div>
</div>


<div id="modalCreateNote" class="modal fade" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" style="font-weight: bold">
                    {{ noteDialogMode === 'create' ? 'Create' : 'View'}} Note
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="row mt-3">
                    <div class="col">
                        <label for="noteVisibility">Visibility</label>
                        <select class="form-select dropdown input-label" [disabled]="noteDialogMode === 'view'" [(ngModel)]="noteVisibility" id="noteVisibility">
                            <option *ngFor="let x of noteVisibilities" [value]="x.id">{{ x.name }}</option>
                        </select>
                    </div>

                    <div class="col">
                        <label for="noteType">Type</label>
                        <select class="form-select dropdown input-label" [disabled]="noteDialogMode === 'view'" [(ngModel)]="noteType" id="noteType">
                            <option *ngFor="let x of noteTypes" [value]="x.id">{{ x.name }}</option>
                        </select>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col">
                        <label for="noteText">Text</label>
                        <textarea class="form-control input-label" [readonly]="noteDialogMode === 'view'"
                                  [(ngModel)]="noteText" id="noteText" name="noteText">
                        </textarea>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                    Close
                </button>
                <button *ngIf="noteDialogMode === 'create'" type="button" class="btn btn-primary" [disabled]="!noteText" (click)="dialog.close(true)">
                    OK
                </button>
            </div>
        </div>
    </div>
</div>


<!--#endregion - Modal Forms - -->
